webpackJsonp([31],{

/***/ 77:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  var path = props.location.search.match(/path=(.*)&_storyblok=/) ? props.location.search.match(/path=(.*)&_storyblok=/)[1] : '';

  props.history.push('/' + path);
  return _react2.default.createElement('div', null);
};

/***/ })

});


// WEBPACK FOOTER //
// templates/src/containers/Editor.699bb221.js